import {Component, Input, OnInit} from '@angular/core';
import {ExcTranslation} from 'exc-core-v2';
import {ApplicationService} from '../../services/application.service';
import {ExcSecurityService} from 'exc-security-v2';
import {ExcRestService} from 'exc-rest-v2';
import {ExgModalService} from 'exc-controls-v2';

@Component({
  selector: 'app-overlay-pdf-editor',
  templateUrl: './overlay-pdf-editor.component.html',
  styles: [
  ]
})
export class OverlayPdfEditorComponent extends ExcTranslation implements OnInit {
  @Input()
  set data(value: any) {
    if (value) {
      this._data = value;
    }
  }
  get data(): any {
    return this._data;
  }
  private _data: any = {};

  init = true;
  answers: {[placeholder: string]: any} = {};
  answersLength = 0;

  documentPDF = {
    isLoading: false,
    docPDF: {} as any,
    loadData: () => {
      const SELF = this;
      SELF.documentPDF.isLoading = true;

      SELF.excRestService
        .get(
          SELF.excRestService.computeUrl('DocumentR', {
            dokID: this.data.dokID
          }), { })
        .subscribe(
          (data: any) => {
            if (data.success) {
              SELF.documentPDF.docPDF = data.data;
              console.log(SELF.documentPDF.docPDF);
            }
            if (SELF.init) {
              SELF.init = false;
            }
            SELF.documentPDF.isLoading = false;
          }
        );
    },
  };

  constructor(
    public excRestService: ExcRestService,
    public appSvc: ApplicationService,
    public excSecurity: ExcSecurityService,
    private modalService: ExgModalService,
  ) {
    super();
  }

  ngOnInit(): void {
    this.registerEvents();
    this.documentPDF.loadData();
  }

  registerEvents(): void {

  }

  selection(dokID: any, event: boolean): void {
    this.answers[dokID] = event;
    this.answersLength = 0;
    for (const key of Object.keys(this.answers)) {
      if (this.answers[key]) {
        this.answersLength++;
      }
    }
  }

  generatePageNumbers(dokPages: number): number[] {
    const pageNumbers: number[] = [];
    for (let i = 1; i <= dokPages; i++) {
      pageNumbers.push(i);
    }
    return pageNumbers;
  }

  openModalCreateFile(): void {
    if (this.answersLength === 0) {
      return;
    }
    this.modalService.show('ModalNewPdfComponent', {
      auftragData: this.data.auftragData,
      originalDocData: this.documentPDF.docPDF,
      taskList: this.data.taskList
    })
      .subscribe((rtVal: any) => {
        if (rtVal && rtVal.filename) {
          let pages = '';

          for (const key of Object.keys(this.answers)) {
            if (this.answers[key]) {
              pages += key + ';';
            }
          }

          let objIDToSave = '';
          if (rtVal.uiSaveInCase) {
            objIDToSave = this.data.auftragData?.auID || this.data.objID;
          } else {
            objIDToSave = rtVal.vorgID;
          }

          this.excRestService.post(
            this.excRestService.computeUrl('PDFSplit', {
              dokID: this.documentPDF.docPDF.dokID
            }), {
              filename: rtVal.filename,
              selectedPages: pages.slice(0, -1),
              dok_objID: objIDToSave,
              dok_enmIdent_DokTyp: rtVal.dok_enmIdent_DokTyp
            }
          ).subscribe((rtValue: any) => {
            if (rtValue && rtValue.success) {
              this.modalService
                .showToast('Datei wurde erstellt'
                  , 'md-toast bg-green'
                  , 'far fa-file-image');
              this.data.Events.Document?.UpdateDialog?.Closed.emit();
              this.answers = {};
              this.answersLength = 0;
            }
          });
        }
      });
  }
}
